import herbalDialog from './components/dlgHerbal';
import mlDialog from './components/dlgMl';

const components = [herbalDialog, mlDialog];

const install = function (Vue) {
  if (install.installed) return;

  install.installed = true;

  components.forEach((com) => {
    Vue.component(com.name, com);
  });
};

export default {
  install,
  ...components,
};
